
import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
//redux
import { useSelector, useDispatch } from 'react-redux';
//----------------------------------------------------
import { ITable } from '../iComponents/iTable/ITable';
import Iloading from '../iComponents/iLoading/Iloading';
import { getChargesList } from '../../../store/ChargesList/actions';

//-----------------------------------------------------------
const ChargesList = ({selectedRow}:any) => {
  const [numOrder, setnumOrder] = useState('');
  const groupNameModal = 'ChargesViewList';
  const valuesSizePagination = [10, 20, 30, 40, 50, 100];
  const { data, isLoading} = useSelector(
    (state: any) => state.chargesList,
  );


  const [chargesList, setChargesList] = useState<any[]>([]);

  const dispatch = useDispatch();


  useEffect(() => {
    setnumOrder(selectedRow.Number)
  }, [selectedRow]);


  useEffect(() => {
    if(data){
      setChargesList(data);
    }
  }, [data]);

  useEffect(() => {
    dispatch(getChargesList(selectedRow.GUID));
  }, [selectedRow]);

  const columns = [
    {
        text: 'Type',
        visibleInTable: true,
        dataField: 'Type',
    },
    {
        text: 'Tax Amount In Currency',
        visibleInTable: true,
        dataField: 'TaxAmountInCurrency',
    },
    {
        text: 'Charge Definition Code',
        visibleInTable: true,
        dataField: 'ChargeDefinition_Code',
    },
    {
        text: 'Quantity',
        visibleInTable: true,
        dataField: 'Quantity',
    },
    {
        text: 'Charge Definition Description',
        visibleInTable: true,
        dataField: 'ChargeDefinition_Description',
    },
    {
        text: 'Price In Currency',
        visibleInTable: true,
        dataField: 'PriceInCurrency',
    },
    {
        text: 'Units',
        visibleInTable: true,
        dataField: 'Units',
    },
    {
      text: 'Tax Definition Code',
      visibleInTable: true,
      dataField: 'TaxDefinition_Code',
  },
  {
      text: 'Price In Currency',
      visibleInTable: true,
      dataField: 'PriceInCurrency',
  },
];


  return (
    <div className="commodityDetails">
      <>
        <div id="contentToprint">
          <React.Fragment>
            <div className="search">
              <div className="ml-6 col">
                <h2>{'Charges - ' + numOrder}</h2>
              </div>
            </div>
            <div className="pageContentIform">
              <Container fluid>
                <Row>
                <div className="container-sm">
                    <Iloading loading={isLoading}/>
                </div>

                  {chargesList.length > 0 ? (
                    <>
                      <ITable
                        CountItems={chargesList.length}
                        enableTemporaryView={false}
                        valuesSizePagination={valuesSizePagination}
                        handlerPaginationState={() => { }}
                        data={chargesList}
                        isLoading={isLoading}
                        fields={columns}
                        tableColumns={columns}
                        headerColorT={'bg-primary text-white'}
                        handlePopUpState={()=>{}}
                        groupName={groupNameModal}
                        enableView={false}
                      />
                    </>
                  ) : null}
                </Row>
              </Container>
            </div>
          </React.Fragment>
        </div>
      </>
    </div>
  );
};
export default ChargesList;
